import React from 'react'
import styled from 'styled-components'

import { theme } from '../../../theme'

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  helper?: string
  error?: string
}

const Container = styled.div<{ className?: string }>`
  display: flex;
  align-items: flex-start;
  ${(props) => props.className}
`

const StyledInput = styled.input`
  width: 20px;
  height: 20px;
  border: 1px solid ${theme.colors.greyText};
  border-radius: ${theme.radius.default};
  background-color: white;
  margin-top: 0.125rem;

  &:checked {
    background-color: ${theme.colors.altovita};
    border-color: ${theme.colors.altovita};
  }

  &:focus {
    box-shadow: 0 0 0 2px ${theme.colors.altovita};
  }
`

const LabelContainer = styled.div`
  margin-left: 10px;
  flex: 1;
`

const StyledLabel = styled.label`
  color: ${theme.colors.greyText};
  cursor: pointer;
`

const HelperText = styled.p`
  margin-top: 0.25rem;
  font-size: 0.875rem;
  color: ${theme.colors.greyText};
`

const ErrorText = styled.p`
  margin-top: 0.25rem;
  font-size: 0.875rem;
  color: ${theme.colors.error};
`

export const Checkbox = ({
  label,
  helper,
  error,
  className = '',
  ...props
}: CheckboxProps) => (
  <Container className={className}>
    <StyledInput type="checkbox" {...props} />

    {label && (
      <LabelContainer>
        <StyledLabel htmlFor={props.id}>{label}</StyledLabel>

        {helper && !error && <HelperText>{helper}</HelperText>}

        {error && <ErrorText>{error}</ErrorText>}
      </LabelContainer>
    )}
  </Container>
)
